// import { Autocomplete, Backdrop, Button, Chip, Divider, FormControl, FormControlLabel, Grid, IconButton, Radio, RadioGroup, Switch, TextField, Typography } from '@mui/material';
// import { useFormik } from 'formik';
// import React, { Fragment, useEffect, useState } from 'react';
// import * as yup from 'yup';
// import CustomDataGrid from '../../../../../components/dataTable/customDataGrid';
// import City from '../../../../../components/utils/dropDown/city';
// import Country from '../../../../../components/utils/dropDown/country';
// import State from '../../../../../components/utils/dropDown/state';
// import CustomTextField from '../../../../../components/utils/input/customTextField';
// import Modal from '../../../../../components/utils/modal/modal';
// import { useDispatch } from 'react-redux';
// import axios from 'axios';
// import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
// import DeletePage from '../../../../../components/utils/deleteModal/deletePage';
// import _ from 'lodash';
// import { Delete, EditNote } from '@mui/icons-material';
// import Loader from '../../../../../components/loader/loader';
// import { Helmet } from 'react-helmet-async';

// const WareHouse = () => {
//   const dispatch = useDispatch()
//     const pageOption = [10, 25, 50, 100]
//     const [page, setPage] = useState(0)
//     const [rowsPerPage, setRowsPerPage] = useState(100);
//     // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
//     const [pageCount, setPageCount] = useState(0);
//     const [search, setSearch] = useState('')
//     const [data, setData] = useState([])
//     const [open, setOpen] = useState(false);
//     const [isEdit, setIsEdit] = useState(false)
//     const [openDialog, setOpenDialog] = useState(false)
//     const [active, setActive] = useState(false)
//     const [activeId, setActiveId] = useState(null)
//     const [countryObj,setCountryObj] = useState(null)
//     const [stateObj, setStateObj] = useState(null)
//     const [cityObj, setCityObj] = useState(null);
//     const [isLoader, setIsLoader] = useState(false); //loader
//         const [status,setStatus] =useState()
    
//     const validation = yup.object({
//       name: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
//       contactname: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
//       address1: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
//       address2: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
     
//       pincode: yup.string().required().min(6, "Minimum 6 digits required").max(8, "Maximum 8 digits allowed"),
//       country: yup.object().required('Select anyone Country'),
//       state:yup.object().required('Select anyone state'),
//       city:yup.object().required('Select anyone city'),
//       phone: yup.string().matches(/^\S.*$/,"Empty space not allowed!").matches(/^\d+$/, "Only digits are allowed")
//       .notRequired('This field is required!'),
//       mobile: yup.string().matches(/^\S.*$/, "Empty space not allowed!").matches(/^\d+$/, "Only digits are allowed")
//       .notRequired(),
//       email: yup.string("Enter your email").email("Enter a valid email").required("This field is required!"),
//       limitation:yup.string().matches(/^\S.*$/, "Empty space not allowed!") 
//       .matches(/^\d+$/, "Only digits are allowed"),

//       shortName:yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),

//       gstin:yup.string()
//       .matches(/^([0][1-9]|[1-2][0-9]|[3][0-8])[A-Z]{3}[ABCFGHLJPTF]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]/, 'Invalid GSTIN format')
//       .required('This field is required!'),
//       fssai:yup.string()
//       .matches(/[A-Z]{5}[0-9]{4}[A-Z]{1}/, 'Invalid PAN number format')
//       .required('PAN number is required'),
//       // outletOption:yup.string().required('This field is required!'),
//       gstApplicable:yup.string().required('This field is required!'),
//       mainWarehouse:yup.string().required('This field is required!'),
//       bankAccNo:yup.string().matches(/^\d{9,18}$/, 'Invalid bank account number format').required('This field is required!'),
//       bankName:yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
//       accName:yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
//       ifscCode:yup.string().matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC code format').required('This field is required!'),
//       // creditLimit:yup.string().matches(/^\S.*$/, "Empty space not allowed!") 
//       // .matches(/^\d+$/, "Only digits are allowed")
//       // .notRequired('This field is required!'),
//       // limitation:yup.string().matches(/^\S.*$/, "Empty space not allowed!") 
//       // .matches(/^\d+$/, "Only digits are allowed")
//       // .required('This field is required!'),
//       wallet_balance:yup.string().matches(/^\S.*$/, "Empty space not allowed!") 
//       .matches(/^\d+$/, "Only digits are allowed")
//       .required('This field is required!'),
//     })

//     const formik = useFormik({
//       initialValues:{
//         name:'',
//         contactname:'',
//         country : null,
//         state:null,
//         city : null,
//         address1:"",
//         address2:"",
//         phone:"",
//         mobile:"",
//         email: "",
//         pincode:"",
//         limitation:"",
//         shortName:"",
//         gstin:"",
//         fssai:"",
//         // outletOption:"",
//         gstApplicable:"",
//         mainWarehouse:"",
//         bankAccNo:"",
//         bankName:"",
//         accName:"",
//         ifscCode:"",
//         // pincode:"",
//         // additionalOption:"",
//         // creditLimit:"",
//         // limitation:"",
//         wallet_balance:""
//       },
//       validationSchema: validation,
//       onSubmit : isEdit ? handleUpdate : handleCreate
//     })

//     const columns = [
//         {
//           field: "sno",
//           headerName: "S.no",
//           minWidth: 70,
//           maxWidth: 100,
//           headerAlign: "center",
//           align: "center",
//           sortable: false,
//         },
//         {
//           field: "id",
//           headerName: "Id",
//           flex: 1,
//           minWidth: 70,
//           maxWidth: 100,
//           headerAlign: "center",
//           align: "center",
//           sortable: false,
//         },
//         {
//           field: "name",
//           headerName: "Warehouse",
//          minWidth: 150,
//           headerAlign: "center",
//           align: "center",
//           sortable: false,
//         },
//         {
//           field: "shortName",
//           headerName: "Short Name",
//           minWidth: 100,
//           headerAlign: "center",
//           align: "center",
//           sortable: false,
//         },
//         {
//           field: "contactname",
//           headerName: "Name",
//          minWidth: 170,
//           headerAlign: "center",
//           align: "center",
//           sortable: false,
//         },
//         {
//           field: "phone",
//           headerName: "Phone No.",
//          minWidth: 100,
//           headerAlign: "left",
//           align: "left",
//           sortable: false,
//         },
//         {
//           field: "mobile",
//           headerName: "Mobile No.",
//          minWidth: 100,
//           headerAlign: "left",
//           align: "left",
//           sortable: false,
//         },
//         {
//           field: "add1",
//           headerName: "Address 1",
//          minWidth: 100,
//           headerAlign: "left",
//           align: "left",
//           sortable: false,
//         },
        
//         {
//           field: "add2",
//           headerName: "Address 2",
//          minWidth: 100,
//           headerAlign: "left",
//           align: "left",
//           sortable: false,
//         },
        
      
//         {
//           field: "isActive",
//           headerName: "Status",
//          minWidth: 100,
//           headerAlign: "center",
//           align: "center",
//           disableExport: true ,
//           sortable: false,
//           disableColumnMenu: true,
//           renderCell: (params) => (
//             <div className="">
//             <Chip size='small' color={params.row.isActive ? 'success' : 'error'} label={params.row.isActive ? 'Active' : 'Deactive'}/>
//           </div>
//           )
//         },
//         {
//           field: 'action',
//           headerName: 'Action',
//          minWidth: 100,
//           minWidth: 100,
//           headerAlign: "center",
//           align: "center",
//           disableExport: true ,
//           editable: false,
//           sortable: false,
//           disableColumnMenu: true,
//           renderCell: (params) => (
//             <div className='flex justify-center w-full'>
//               <IconButton onClick={()=>onEdit(params.row)} >
//                 <EditNote sx={{color:"#1972d2",fontSize:22}}/>
//               </IconButton>
//               <IconButton onClick={() => OnDelete(params.id)}>
//                 <Delete sx={{color:"red",fontSize:22}}/>
//               </IconButton>
//             </div>
//           ),
//         },

//       ];
    
//       const rows = _.map(data, (val,idx)=>({
//   id:val.id,
//   sno: ++idx,
//   name: val.wh_name,
//   contactname: val.contact_name,
//   add1: val.add1,
//   add2: val.add2,
//   add3: val.add3,
//   add4: val.add4,
//   city: val.city_id,
//   city_name: val.city_name,
//   country: val.country_id,
//   country_name: val.country_name,
//   email: val.email,
//   isActive : val.is_active,
//   mobile: val.mobile,
//   phone: val.phone,
//   pincode: val.pincode,
//   state: val.state_id,
//   state_name: val.state_name,
//   limitation:val.limitation,
//   shortName : val.short_name || "-",
//   main_warehouse:val.main_warehouse,
//   bankName: val.bankname,
//   bankAccNo:val.bankacno,
//   ifsccode:val.ifsccode,
//   accName:val.acname,
//   gstin: val.gstin,
//   fssai:val.fssai,
//   wallet_balance:val.wallet_balance,
//   is_gst:val.is_gst
// }))
      
// const props = {
//         rows : rows,
//         columns : columns,
//         search : search,
//         setSearch : setSearch,
//         page: page,
//         setPage : setPage,
//         rowsPerPage : rowsPerPage,
//         setRowsPerPage : setRowsPerPage,
//         pageCount : pageCount,
//         pageOption : pageOption
//       }

//       const onCreate = ()=>{
//         setOpen(true)
//         formik.resetForm()
//         setIsEdit(false)
//         setCountryObj(null)
//         setCityObj(null)
//         setStateObj(null)
//         }

//     function handleCreate () {
//       const wareData = {
//         wh_name: formik.values.name,
//         contact_name:formik.values.contactname,
//         add1: formik.values.address1,
//         add2: formik.values.address1,
//         add3: "-",
//         add4: "-",
//         city: formik.values.city.id,
//         pincode: formik.values.pincode,
//         state: formik.values.state.id,
//         phone: formik.values.phone,
//         mobile: formik.values.mobile,
//         email: formik.values.email,
//         company_id: 1,
//         country: formik.values.country.id,
//         is_active: active,
//         limitation:parseFloat(formik.values.limitation).toFixed(2),
     
//         short_name: formik.values.shortName,
//         gstin: formik.values.gstin,
//     fssai: formik.values.fssai,
//     outlet_type: formik.values.outletOption==='OWN' ? 1 : formik.values.outletOption==="FRANCHISE" ? 2 : 3,
//     bankacno: formik.values.bankAccNo,
//     bankname: formik.values.bankName,
//     acname: formik.values.accName,
//     ifsccode: formik.values.ifscCode,
//     company_id:1,
//     is_gst: formik.values.gstApplicable === 'Yes' ? true : false,
//     main_warehouse: formik.values.mainWarehouse === 'Yes' ? true : false,
//     franchise_type :  formik.values.additionalOption === "COFO" ? 1 : 2,
//     credit_limit:formik.values.creditLimit,
//     limitation:parseFloat(formik.values.limitation).toFixed(2),
//     wallet_balance:formik.values.wallet_balance
//       }
//       setIsLoader(true)
//       axios.post(`/v1/warehouse`, wareData)
//       .then(res=>{
//         setOpen(false)
//         getWareHouse()
//         setIsLoader(false)
//         dispatch(setSnackbar(true, 'success', 'Created Successfully'))
//       })
//       .catch(err=>{
//         console.log(err)
//         dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
//         setIsLoader(false)
//       })
//     }
// function onEdit(e){
// console.log(e,"editdata")
// formik.setFieldValue('address1',e.add1)
// formik.setFieldValue('address2',e.add2)
// formik.setFieldValue('address3',"-")
// formik.setFieldValue('address4',"-")
// formik.setFieldValue('phone',e.phone)
// formik.setFieldValue('mobile',e.mobile)
// formik.setFieldValue('email',e.email)
// formik.setFieldValue('name',e.name)
// formik.setFieldValue('contactname',e.contactname)
// setCountryObj(e.country)
// setStateObj(e.state)
// setCityObj(e.city)
// formik.setFieldValue('pincode',e.pincode)
// formik.setFieldValue('limitation' ,e.limitation)

// formik.setFieldValue('shortName', e.shortName)
// formik.setFieldValue('gstin',e.gstin)
// formik.setFieldValue('fssai',e.fssai)
// formik.setFieldValue('bankAccNo',e.bankAccNo)
// formik.setFieldValue('accName',e.accName)
// formik.setFieldValue('ifscCode',e.ifsccode)
// formik.setFieldValue('bankName',e.bankName) 
// formik.setFieldValue('additionalOption' , e.franchise_type === 1 ? "COFO" : "FOFO")   
// // formik.setFieldValue('creditLimit' , e.creditLimit)
// // formik.setFieldValue('limitation' ,e.limitation)
// formik.setFieldValue('wallet_balance' , e.wallet_balance)

// formik.setFieldValue('mainWarehouse' ,e.main_warehouse ? 'Yes' : 'No' )
// formik.setFieldValue('gstApplicable' ,e.is_gst ? 'Yes' : 'No' )

// setIsEdit(true)
// setOpen(true)
// setActive(e.isActive)
// setActiveId(e.id)
// }
//     function handleUpdate(){
      
// const wareData = {
//   contact_name:formik.values.contactname,

//   wh_name: formik.values.name,
//   add1: formik.values.address1,
//   add2: formik.values.address2,
//   add3: "-",
//   add4: "-",
//   city: formik.values.city.id,
//   pincode: formik.values.pincode,
//   state: formik.values.state.id,
//   phone: formik.values.phone,
//   mobile: formik.values.mobile,
//   email: formik.values.email,
//   company_id: 1,
//   country: formik.values.country.id,
//   is_active: active,
//   limitation:parseFloat(formik.values.limitation).toFixed(2),

//   short_name: formik.values.shortName,
//   gstin: formik.values.gstin,
//   fssai: formik.values.fssai,
//   outlet_type: formik.values.outletOption==='OWN' ? 1 : formik.values.outletOption==="FRANCHISE" ? 2 : 3,
//   bankacno: formik.values.bankAccNo,
//   bankname: formik.values.bankName,
//   acname: formik.values.accName,
//   ifsccode: formik.values.ifscCode,
//   company_id:1,
//   is_gst: formik.values.gstApplicable === 'Yes' ? true : false,
//   main_warehouse: formik.values.mainWarehouse === 'Yes' ? true : false,
//   franchise_type :  formik.values.additionalOption === "COFO" ? 1 : 2,
//   // credit_limit:formik.values.creditLimit,
//   // limitation:parseFloat(formik.values.limitation).toFixed(2),
//   wallet_balance:formik.values.wallet_balance

// }
// setIsLoader(true)
// axios.put(`/v1/warehouse/${activeId}`, wareData)
// .then(res=>{
//   setOpen(false)
//   setIsLoader(false)
//   getWareHouse()
//   dispatch(setSnackbar(true, 'success', 'Updated Successfully'))
// })
// .catch(err=>{
//   dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
//   setIsLoader(false)
// })
//     }

//     function OnDelete(id){
//       setOpenDialog(true)
//       setActiveId(id)
//     }  
    
//     const handleDelete = () =>{
//       setIsLoader(true)
//       axios.delete(`/v1/warehouse/${activeId}`)
//       .then(res=>{
//         setOpenDialog(false)
//         getWareHouse()
//         console.log(res)
//         dispatch(setSnackbar(true, 'success', 'Deleted Successfully'))
//         setIsLoader(false)
//         setOpen(false)
//       })
//       .catch(err=>{
//         dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
//         console.log(err)
//         setIsLoader(false)
//       })
//     console.log('fasdf')
//     }

//     const getWareHouse=()=>{
//       // const url = `/v1/warehouse/${rowsPerPage}/${page + 1}`
//       // const searchUrl = `/v1/warehouse/${rowsPerPage}/${page + 1}/${search}`
//       // axios.get(search === '' ? url : searchUrl)
//       const approvestatus = status ? (status.id === 0 ? 0 : status.id) : 0; // 0: All, 1: Generated, 2: Verified
       
//       axios.get(`/v1/warehouse/${rowsPerPage}/${page + 1}?status=${approvestatus}&search=${search}`)
//       .then(res=>{
//         setData(res.data.data)
//         setPageCount(res.data.meta.pagination.total)
//       })
//       .catch(err=>{
//         setData([])
//         dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
//       })
//     }
//     const handleMobile =(e)=>{
//       formik.setFieldValue('mobile', e.target.value.replace(/\D/g, "").trim())
//     }
//     const handlePhone =(e)=>{
//       formik.setFieldValue('phone', e.target.value.replace(/\D/g, "").trim())
//     }
//     const handleAcc =(e)=>{
//       formik.setFieldValue('bankAccNo', e.target.value.replace(/\D/g, "").trim())
//     }
//     useEffect(()=>{
// getWareHouse()
//     },[rowsPerPage,  page, search,status])
//   return (
//    <Fragment >
//     <Helmet><title>Warehouse</title></Helmet>
//       <Typography variant='h5'>Warehouse</Typography>
//            <Grid container spacing={2} className="p-2 pt-2">
             
//         <Grid item md={3}>
//                  <Autocomplete
//                    size="small"
//                    options={[
//                      { id: 0, fullname: "All" },
//                      { id: 1, fullname: "Active" },
//                      { id: 2, fullname: "Inactive" },
//                    ]}
//                    disableClearable
//                    value={status}
//                    onChange={(e, value) => setStatus(value)} // Update status
//                    getOptionLabel={(option) => option.fullname}
//                    renderInput={(params) => <TextField {...params} placeholder="Select Status" />}
//                  />
//                </Grid>
//                </Grid>
//       {!open &&
//   <Grid className='flex justify-end'>
//     <Button variant='contained' size='small' onClick={onCreate}>Create New</Button>
// </Grid>}
//     {open &&
//     <Modal onClose={setOpen} onSave={formik.handleSubmit} formik={formik} isEdit={isEdit}>
//    <div style={{textAlign:"right"}}>
// <Button variant='outlined' onClick={() => setOpen(false)}>Close</Button>
//   </div>
//   <Grid container spacing={2} >
//  <Grid item xs={12}> <Typography fontSize={16} fontWeight={600} color={"black"}>1. WareHouse Details</Typography></Grid>
//     <Grid item xs={12} md={4} lg={3}>
//       <CustomTextField id='name' value={formik.values.name} title='WareHouse Name' multiple={false} placeholder='Enter company name' onchange={formik.handleChange} errorMsg={formik.touched.name && Boolean(formik.errors.name)} helperText={formik.touched.name && formik.errors.name}/>
//     </Grid>
//     <Grid item xs={12} md={4} lg={3}>
//       <CustomTextField id='shortName' value={formik.values.shortName} title='Short Name' multiple={false} placeholder='Enter Short Name' onchange={formik.handleChange} errorMsg={formik.touched.shortName && Boolean(formik.errors.shortName)} helperText={formik.touched.shortName && formik.errors.shortName}/>
//       </Grid>
//     <Grid item xs={12} md={4} lg={3}>
//       <CustomTextField id='address1' value={formik.values.address1} title='Address 1' multiple={true} placeholder='Enter address' onchange={formik.handleChange} errorMsg={formik.touched.address1 && Boolean(formik.errors.address1)} helperText={formik.touched.address1 && formik.errors.address1}/>
//     </Grid>
//     <Grid item xs={12} md={4} lg={3}>
//       <CustomTextField id='address2' value={formik.values.address2} title='Address 2' multiple={true} placeholder='Enter address' onchange={formik.handleChange} errorMsg={formik.touched.address2 && Boolean(formik.errors.address2)} helperText={formik.touched.address2 && formik.errors.address2}/>
//     </Grid>
//     <Grid item xs={12} md={4} lg={3}>
//       <CustomTextField id='pincode' value={formik.values.pincode} title='Pincode' multiple={false} placeholder='Enter pincode' onchange={formik.handleChange} errorMsg={formik.touched.pincode && Boolean(formik.errors.pincode)} helperText={formik.touched.pincode && formik.errors.pincode}/>
//     </Grid>

//     <Grid item xs={12} md={4} lg={3}>
//       <Country formik={formik} countryId={countryObj}/>

//     </Grid>
//     <Grid item xs={12} md={4} lg={3}>
//       <State formik={formik} stateId={stateObj}/>

//     </Grid>
//     <Grid item xs={12} md={4} lg={3}>
//       <City formik={formik} cityId={cityObj}/>

//     </Grid>
//     <Grid item xs={12}  md={4} lg={3}  >
//   <Typography variant="body1" my={1}> Main WareHouse</Typography>
//     <FormControl sx={{ display: "flex" }}>
//       <RadioGroup
//         aria-labelledby="demo-radio-buttons-group-label"
//         name="mainWarehouse"
//         sx={{ flexDirection: "row", display: "flex" }}
//         onChange={formik.handleChange}
//       >
//         <FormControlLabel
//           value="Yes"
//           control={<Radio size="small" checked={formik.values.mainWarehouse==='Yes'} />}
//           label="Yes"
//         />
//         <FormControlLabel
//           value="No"
//           control={<Radio size="small" checked={formik.values.mainWarehouse==='No'}/>}
//           label="No"
//         />
//       </RadioGroup>
//       <Typography sx={{color:"red",fontSize:12}}>{formik.touched.mainWarehouse && formik.errors.mainWarehouse}</Typography>

//     </FormControl>
//   </Grid>
//     <Grid item xs={12} >
//     <Divider />
//     </Grid>
//     <Grid item xs={12} >
//       <Typography fontSize={16} fontWeight={600} color={"black"}>2. Contact Details</Typography>
//     </Grid>
//     <Grid item xs={12} md={4} lg={3}>
//       <CustomTextField id='contactname' value={formik.values.contactname} title='Name' multiple={false} placeholder='Enter contact name' onchange={formik.handleChange} errorMsg={formik.touched.contactname && Boolean(formik.errors.contactname)} helperText={formik.touched.contactname && formik.errors.contactname}/>
//     </Grid>
//     <Grid item xs={12} md={4} lg={3}>
//       <CustomTextField id='phone' value={formik.values.phone} title='Phone' multiple={false} placeholder='Enter phone No' onchange={handlePhone} errorMsg={formik.touched.phone && Boolean(formik.errors.phone)} helperText={formik.touched.phone && formik.errors.phone}/>
//     </Grid>
//     <Grid item xs={12} md={4} lg={3}>
//       <CustomTextField id='mobile' value={formik.values.mobile} title='Mobile' multiple={false} placeholder='Enter mobile No' onchange={handleMobile} errorMsg={formik.touched.mobile && Boolean(formik.errors.mobile)} helperText={formik.touched.mobile && formik.errors.mobile}/>
//     </Grid>
//     <Grid item xs={12} md={4} lg={3}>
//       <CustomTextField id='email' value={formik.values.email} title='Email' multiple={false} placeholder='Enter email' onchange={formik.handleChange} errorMsg={formik.touched.email && Boolean(formik.errors.email)} helperText={formik.touched.email && formik.errors.email}/>
//     </Grid>
//     <Grid item xs={12} >
//     <Divider />
//     </Grid>
//     <Grid item xs={12} >
//       <Typography fontSize={16} fontWeight={600} color={"black"}>3. Limitation</Typography>
//     </Grid>
//     <Grid item xs={12} md={4} lg={3}>
//       <CustomTextField id='limitation' value={formik.values.limitation} title='Month wise Expense Limitations' multiple={false} placeholder='Enter Limitation' onchange={formik.handleChange} errorMsg={formik.touched.limitation && Boolean(formik.errors.limitation)} helperText={formik.touched.limitation && formik.errors.limitation}/>
//     </Grid>
//     <Grid item xs={12} >
//         <Typography fontSize={16} fontWeight={600} color={"black"}>4. GST Details</Typography>
//       </Grid>
//       <Grid item xs={12} md={4} lg={3}>
//       <CustomTextField id='gstin' value={formik.values.gstin} title='GSTIN' multiple={false} placeholder='Enter gstin' onchange={formik.handleChange} errorMsg={formik.touched.gstin && Boolean(formik.errors.gstin)} helperText={formik.touched.gstin && formik.errors.gstin}/>
//     </Grid>
//     <Grid item xs={12} md={4} lg={3}>
//       <CustomTextField id='fssai' value={formik.values.fssai} title='Pan Number' multiple={false} placeholder='Enter Pan Number' onchange={formik.handleChange} errorMsg={formik.touched.fssai && Boolean(formik.errors.fssai)} helperText={formik.touched.fssai && formik.errors.fssai}/>
//     </Grid>


//   {formik.values.outletOption === 'FRANCHISE' ? (
//   <Grid item xs={12} md={4} lg={3}>
   
//           <CustomTextField id='creditLimit' value={formik.values.creditLimit} title='Credit Limit' multiple={false} placeholder='Enter Credit Limit' onchange={formik.handleChange} errorMsg={formik.touched.creditLimit && Boolean(formik.errors.creditLimit)} helperText={formik.touched.creditLimit && formik.errors.creditLimit}/>
    
    
//   </Grid>
//   ): null}

//   <Grid item xs={12} md={4} lg={3}>
//       <CustomTextField id='wallet_balance' value={formik.values.wallet_balance} title='Wallet Balance' multiple={false} placeholder='Enter wallet balance' onchange={formik.handleChange} errorMsg={formik.touched.wallet_balance && Boolean(formik.errors.wallet_balance)} helperText={formik.touched.wallet_balance && formik.errors.wallet_balance}/>
//     </Grid>
//     <Grid item xs={12}  md={4} lg={3}  >
//   <Typography variant="body1" my={1}> Gst Applicable</Typography>
//     <FormControl sx={{ display: "flex" }}>
//       <RadioGroup
//         aria-labelledby="demo-radio-buttons-group-label"
//         name="gstApplicable"
//         sx={{ flexDirection: "row", display: "flex" }}
//         onChange={formik.handleChange}
//       >
//         <FormControlLabel
//           value="Yes"
//           control={<Radio size="small" checked={formik.values.gstApplicable==='Yes'} />}
//           label="Yes"
//         />
//         <FormControlLabel
//           value="No"
//           control={<Radio size="small" checked={formik.values.gstApplicable==='No'}/>}
//           label="No"
//         />
//       </RadioGroup>
//       <Typography sx={{color:"red",fontSize:12}}>{formik.touched.gstApplicable && formik.errors.gstApplicable}</Typography>

//     </FormControl>
//   </Grid>
//   <Grid item xs={12} >
//         <Typography fontSize={16} fontWeight={600} color={"black"}>5. Bank Details</Typography>
//       </Grid>
//       <Grid item xs={12} md={4} lg={3}>
//       <CustomTextField id='bankAccNo' value={formik.values.bankAccNo} title='Bank Acc No' multiple={false} placeholder='Enter Bank Acc No' onchange={handleAcc} errorMsg={formik.touched.bankAccNo && Boolean(formik.errors.bankAccNo)} helperText={formik.touched.bankAccNo && formik.errors.bankAccNo}/>
//     </Grid>
//     <Grid item xs={12} md={4} lg={3}>
//       <CustomTextField id='bankName' value={formik.values.bankName} title='Bank Name' multiple={false} placeholder='Enter Bank Name' onchange={formik.handleChange} errorMsg={formik.touched.bankName && Boolean(formik.errors.bankName)} helperText={formik.touched.bankName && formik.errors.bankName}/>
//     </Grid>
//     <Grid item xs={12} md={4} lg={3}>
//       <CustomTextField id='accName' value={formik.values.accName} title='Account Holder Name' multiple={false} placeholder='Enter Account Holder Name' onchange={formik.handleChange} errorMsg={formik.touched.accName && Boolean(formik.errors.accName)} helperText={formik.touched.accName && formik.errors.accName}/>
//     </Grid>
//     <Grid item xs={12} md={4} lg={3}>
//       <CustomTextField id='ifscCode' value={formik.values.ifscCode} title='IFSC Code' multiple={false} placeholder='Enter IFSC Code' onchange={formik.handleChange} errorMsg={formik.touched.ifscCode && Boolean(formik.errors.ifscCode)} helperText={formik.touched.ifscCode && formik.errors.ifscCode}/>
//     </Grid>

//   </Grid>
//     </Modal>
//     }
// <Grid className='bg-white rounded-md p-2 my-3'>
// <CustomDataGrid props={props}/>
// </Grid>
// <Backdrop open={openDialog} sx={{zIndex:1350}}>
//   <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete}/>
// </Backdrop>
// {/* <Loader isLoader={isLoader}/> */}
//    </Fragment>
//   )
// }

// export default WareHouse

//warehouse rest column added 

import { Autocomplete, Backdrop, Button, Chip, Divider, FormControl, FormControlLabel, Grid, IconButton, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import React, { Fragment, useEffect, useState } from 'react';
import * as yup from 'yup';
import CustomDataGrid from '../../../../../components/dataTable/customDataGrid';
import City from '../../../../../components/utils/dropDown/city';
import Country from '../../../../../components/utils/dropDown/country';
import State from '../../../../../components/utils/dropDown/state';
import CustomTextField from '../../../../../components/utils/input/customTextField';
import Modal from '../../../../../components/utils/modal/modal';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
import DeletePage from '../../../../../components/utils/deleteModal/deletePage';
import _ from 'lodash';
import { Delete, EditNote } from '@mui/icons-material';
import Loader from '../../../../../components/loader/loader';
import { Helmet } from 'react-helmet-async';
import WarehouseStatus from './warehousestatus';
import ProductMapping from './productmap';

const WareHouse = () => {
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [pageCount, setPageCount] = useState(0);
  const [search, setSearch] = useState('');
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [active, setActive] = useState(false);
  const [activeId, setActiveId] = useState(null);
  const [countryObj, setCountryObj] = useState(null);
  const [stateObj, setStateObj] = useState(null);
  const [cityObj, setCityObj] = useState(null);
  const [isLoader, setIsLoader] = useState(false);
  const [status, setStatus] = useState();
  const [openResetModal, setOpenResetModal] = useState(false);
  const [warehouseToReset, setWarehouseToReset] = useState(null);
   const [selectedOutlet, setSelectedOutlet] = useState(null);
const [openDialog1, setOpenDialog1] = useState(false);     // Outlet status
const [openProduct, setOpenProduct] = useState(false);     // Product mapping
const [selectedOutletId, setSelectedOutletId] = useState(null);
const [selectedOutletName, setSelectedOutletName] = useState('');
const [closedStatus, setClosedStatus] = useState({});       // Stores outlet closed status keyed by ID

  const validation = yup.object({
    name: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
    contactname: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
    address1: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
    address2: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
    pincode: yup.string().required().min(6, "Minimum 6 digits required").max(8, "Maximum 8 digits allowed"),
    country: yup.object().required('Select anyone Country'),
    state: yup.object().required('Select anyone state'),
    city: yup.object().required('Select anyone city'),
    phone: yup.string().matches(/^\S.*$/, "Empty space not allowed!").matches(/^\d+$/, "Only digits are allowed")
      .notRequired('This field is required!'),
    mobile: yup.string().matches(/^\S.*$/, "Empty space not allowed!").matches(/^\d+$/, "Only digits are allowed")
      .notRequired(),
    email: yup.string("Enter your email").email("Enter a valid email").required("This field is required!"),
    limitation: yup.string().matches(/^\S.*$/, "Empty space not allowed!")
      .matches(/^\d+$/, "Only digits are allowed"),
    shortName: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
    gstin: yup.string()
      .matches(/^([0][1-9]|[1-2][0-9]|[3][0-8])[A-Z]{3}[ABCFGHLJPTF]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]/, 'Invalid GSTIN format')
      .required('This field is required!'),
    fssai: yup.string()
      .matches(/[A-Z]{5}[0-9]{4}[A-Z]{1}/, 'Invalid PAN number format')
      .required('PAN number is required'),
    gstApplicable: yup.string().required('This field is required!'),
    mainWarehouse: yup.string().required('This field is required!'),
    bankAccNo: yup.string().matches(/^\d{9,18}$/, 'Invalid bank account number format').required('This field is required!'),
    bankName: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
    accName: yup.string().matches(/^\S.*$/, "Empty space not allowed!").required('This field is required!'),
    ifscCode: yup.string().matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC code format').required('This field is required!'),
    wallet_balance: yup.string().matches(/^\S.*$/, "Empty space not allowed!")
      .matches(/^\d+$/, "Only digits are allowed")
      .required('This field is required!'),
  });

  const formik = useFormik({
    initialValues: {
      name: '',
      contactname: '',
      country: null,
      state: null,
      city: null,
      address1: "",
      address2: "",
      phone: "",
      mobile: "",
      email: "",
      pincode: "",
      limitation: "",
      shortName: "",
      gstin: "",
      fssai: "",
      gstApplicable: "",
      mainWarehouse: "",
      bankAccNo: "",
      bankName: "",
      accName: "",
      ifscCode: "",
      wallet_balance: ""
    },
    validationSchema: validation,
    onSubmit: isEdit ? handleUpdate : handleCreate
  });

  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      minWidth: 70,
      maxWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "id",
      headerName: "Id",
      flex: 1,
      minWidth: 70,
      maxWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "name",
      headerName: "Warehouse",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "shortName",
      headerName: "Short Name",
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "contactname",
      headerName: "Name",
      minWidth: 170,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "phone",
      headerName: "Phone No.",
      minWidth: 100,
      headerAlign: "left",
      align: "left",
      sortable: false,
    },
    {
      field: "mobile",
      headerName: "Mobile No.",
      minWidth: 100,
      headerAlign: "left",
      align: "left",
      sortable: false,
    },
    {
      field: "add1",
      headerName: "Address 1",
      minWidth: 100,
      headerAlign: "left",
      align: "left",
      sortable: false,
    },
    {
      field: "add2",
      headerName: "Address 2",
      minWidth: 100,
      headerAlign: "left",
      align: "left",
      sortable: false,
    },
    {
      field: "isActive",
      headerName: "Status",
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      disableExport: true,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className="">
          <Chip size='small' color={params.row.isActive ? 'success' : 'error'} label={params.row.isActive ? 'Active' : 'Deactive'} />
        </div>
      )
    },
     {
        field: 'resetcount',
        headerName: 'Reset Count',
        minWidth: 200,
        // minWidth: 100,
        headerAlign: "center",
        disableExport: true ,
        align: "center",
        editable: false,
        sortable: false,
        disableColumnMenu: true,
        renderCell: (params) => (
          <div className='flex justify-center w-full'>
         <IconButton>
         {params && params.id && (
                    <Button 
                    variant='contained' size='small' sx={{ borderRadius: '120px',fontSize: 10 }}
                    
                    onClick={() => OnReset(params.id)}>
                        Reset Count
                    </Button>
                )}
         {/* <Button onClick={() => OnReset(params.id)}>Reset</Button> */}
                {/* <Button sx={{ color: 'orange', fontSize: 22 }}  onClick={() => handleOpenResetModal(params.row.id)}>Reset</Button> */}
              </IconButton>
        </div>
        ),
      },
    {
      field: 'action',
      headerName: 'Action',
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      disableExport: true,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className='flex justify-center w-full'>
          <IconButton onClick={() => onEdit(params.row)} >
            <EditNote sx={{ color: "#1972d2", fontSize: 22 }} />
          </IconButton>
          <IconButton onClick={() => OnDelete(params.id)}>
            <Delete sx={{ color: "red", fontSize: 22 }} />
          </IconButton>
        </div>
      ),
    },
  ];

  const rows = _.map(data, (val, idx) => ({
    id: val.id,
    sno: ++idx,
    name: val.wh_name,
    contactname: val.contact_name,
    add1: val.add1,
    add2: val.add2,
    add3: val.add3,
    add4: val.add4,
    city: val.city_id,
    city_name: val.city_name,
    country: val.country_id,
    country_name: val.country_name,
    email: val.email,
    isActive: val.is_active,
    mobile: val.mobile,
    phone: val.phone,
    pincode: val.pincode,
    state: val.state_id,
    state_name: val.state_name,
    limitation: val.limitation,
    shortName: val.short_name || "-",
    main_warehouse: val.main_warehouse,
    bankName: val.bankname,
    bankAccNo: val.bankacno,
    ifsccode: val.ifsccode,
    accName: val.acname,
    gstin: val.gstin,
    fssai: val.fssai,
    wallet_balance: val.wallet_balance,
    is_gst: val.is_gst
  }));

  const props = {
    rows: rows,
    columns: columns,
    search: search,
    setSearch: setSearch,
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    pageOption: pageOption
  };

  const onCreate = () => {
    setOpen(true);
    formik.resetForm();
    setIsEdit(false);
    setCountryObj(null);
    setCityObj(null);
    setStateObj(null);
  };

  function handleCreate() {
    const wareData = {
      wh_name: formik.values.name,
      contact_name: formik.values.contactname,
      add1: formik.values.address1,
      add2: formik.values.address2,
      add3: "-",
      add4: "-",
      city: formik.values.city.id,
      pincode: formik.values.pincode,
      state: formik.values.state.id,
      phone: formik.values.phone,
      mobile: formik.values.mobile,
      email: formik.values.email,
      company_id: 1,
      country: formik.values.country.id,
      is_active: active,
      limitation: parseFloat(formik.values.limitation).toFixed(2),
      short_name: formik.values.shortName,
      gstin: formik.values.gstin,
      fssai: formik.values.fssai,
      gstApplicable: formik.values.gstApplicable,
      main_warehouse: formik.values.mainWarehouse === 'Yes' ? true : false,
      bankacno: formik.values.bankAccNo,
      bankname: formik.values.bankName,
      acname: formik.values.accName,
      ifsccode: formik.values.ifscCode,
      is_gst: formik.values.gstApplicable === 'Yes' ? true : false,
      wallet_balance: formik.values.wallet_balance,
    };
    setIsLoader(true);
    axios.post(`/v1/warehouse`, wareData)
      .then(res => {
        setOpen(false);
        getWareHouse();
        setIsLoader(false);
        dispatch(setSnackbar(true, 'success', 'Created Successfully'));
      })
      .catch(err => {
        console.log(err);
        dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message));
        setIsLoader(false);
      });
  }

  function onEdit(e) {
    formik.setFieldValue('address1', e.add1);
    formik.setFieldValue('address2', e.add2);
    formik.setFieldValue('phone', e.phone);
    formik.setFieldValue('mobile', e.mobile);
    formik.setFieldValue('email', e.email);
    formik.setFieldValue('name', e.wh_name || e.name);
    formik.setFieldValue('contactname', e.contact_name || e.contactname);
    setCountryObj(e.country);
    setStateObj(e.state);
    setCityObj(e.city);
    formik.setFieldValue('pincode', e.pincode);
    formik.setFieldValue('limitation', e.limitation);
    formik.setFieldValue('shortName', e.short_name || e.shortName);
    formik.setFieldValue('gstin', e.gstin);
    formik.setFieldValue('fssai', e.fssai);
    formik.setFieldValue('bankAccNo', e.bankAccNo);
    formik.setFieldValue('accName', e.accName);
    formik.setFieldValue('ifscCode', e.ifsccode);
    formik.setFieldValue('bankName', e.bankName);
    formik.setFieldValue('mainWarehouse', e.main_warehouse ? 'Yes' : 'No');
    formik.setFieldValue('gstApplicable', e.is_gst ? 'Yes' : 'No');
    formik.setFieldValue('wallet_balance', e.wallet_balance);

    setIsEdit(true);
    setOpen(true);
    setActive(e.is_active);
    setActiveId(e.id);
  }

  function handleUpdate() {
    const wareData = {
      contact_name: formik.values.contactname,
      wh_name: formik.values.name,
      add1: formik.values.address1,
      add2: formik.values.address2,
      add3: "-",
      add4: "-",
      city: formik.values.city.id,
      pincode: formik.values.pincode,
      state: formik.values.state.id,
      phone: formik.values.phone,
      mobile: formik.values.mobile,
      email: formik.values.email,
      company_id: 1,
      country: formik.values.country.id,
      is_active: active,
      limitation: parseFloat(formik.values.limitation).toFixed(2),
      short_name: formik.values.shortName,
      gstin: formik.values.gstin,
      fssai: formik.values.fssai,
      gstApplicable: formik.values.gstApplicable,
      main_warehouse: formik.values.mainWarehouse === 'Yes' ? true : false,
      bankacno: formik.values.bankAccNo,
      bankname: formik.values.bankName,
      acname: formik.values.accName,
      ifsccode: formik.values.ifscCode,
      is_gst: formik.values.gstApplicable === 'Yes' ? true : false,
      wallet_balance: formik.values.wallet_balance,
    };
    setIsLoader(true);
    axios.put(`/v1/warehouse/${activeId}`, wareData)
      .then(res => {
        setOpen(false);
        setIsLoader(false);
        getWareHouse();
        dispatch(setSnackbar(true, 'success', 'Updated Successfully'));
      })
      .catch(err => {
        dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message));
        setIsLoader(false);
      });
  }

  function OnDelete(id) {
    setOpenDialog(true);
    setActiveId(id);
  }
  const handleDelete = () => {
    setIsLoader(true);
    axios.delete(`/v1/warehouse/${activeId}`)
      .then(res => {
        setOpenDialog(false);
        getWareHouse();
        dispatch(setSnackbar(true, 'success', 'Deleted Successfully'));
        setIsLoader(false);
        setOpen(false);
      })
      .catch(err => {
        dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message));
        setIsLoader(false);
      });
  };
function OnReset(id){
    setOpenDialog1(true)
    setActiveId(id)
    setSelectedOutletId(id);
    setClosedStatus((prev) => ({
        ...prev,
        [id]: prev[id] !== undefined ? prev[id] : 0 // Default status to 0 (open)
    }));
  }    
  function OnAssignProduct(id,name){
    // const selectedOutlet = outletData.find(outlet => outlet.id === id);
    // setFromOutlet(selectedOutlet || null);
    formik.resetForm();
    setSelectedOutletName(name);
    setOpenProduct(true)
    setActiveId(id)
    setSelectedOutletId(id);
   
    setClosedStatus((prev) => ({
        ...prev,
        [id]: prev[id] !== undefined ? prev[id] : 0 // Default status to 0 (open)
    }));

    console.log(selectedOutlet,"selectedOutlet");
    
  }   
  // Reset Count handlers
  const onResetWarehouse = (id) => {
    setWarehouseToReset(id);
    setOpenResetModal(true);
  };

  const closeResetModal = () => {
    setWarehouseToReset(null);
    setOpenResetModal(false);
  };

  const handleResetWarehouse = () => {
    setIsLoader(true);
    axios.post(`/v1/warehouse/reset/${warehouseToReset}`)
      .then(() => {
        dispatch(setSnackbar(true, 'success', 'Reset count successful'));
        getWareHouse();
        closeResetModal();
        setIsLoader(false);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, 'error', err.response?.data?.errors[0]?.message || 'Error resetting'));
        setIsLoader(false);
      });
  };

  const getWareHouse = () => {
    const approvestatus = status ? (status.id === 0 ? 0 : status.id) : 0;
    axios.get(`/v1/warehouse/${rowsPerPage}/${page + 1}?status=${approvestatus}&search=${search}`)
      .then(res => {
        setData(res.data.data);
        setPageCount(res.data.meta.pagination.total);
      })
      .catch(err => {
        setData([]);
        dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message));
      });
  };

  const handleMobile = (e) => {
    formik.setFieldValue('mobile', e.target.value.replace(/\D/g, "").trim());
  };
  const handlePhone = (e) => {
    formik.setFieldValue('phone', e.target.value.replace(/\D/g, "").trim());
  };
  const handleAcc = (e) => {
    formik.setFieldValue('bankAccNo', e.target.value.replace(/\D/g, "").trim());
  };

  useEffect(() => {
    getWareHouse();
  }, [rowsPerPage, page, search, status]);

  return (
    <Fragment>
      <Helmet><title>Warehouse</title></Helmet>
      <Typography variant='h5'>Warehouse</Typography>

      <Grid container spacing={2} className="p-2 pt-2">
             
        <Grid item md={3}>
                 <Autocomplete
                   size="small"
                   options={[
                     { id: 0, fullname: "All" },
                     { id: 1, fullname: "Active" },
                     { id: 2, fullname: "Inactive" },
                   ]}
                   disableClearable
                   value={status}
                   onChange={(e, value) => setStatus(value)} // Update status
                   getOptionLabel={(option) => option.fullname}
                   renderInput={(params) => <TextField {...params} placeholder="Select Status" />}
                 />
               </Grid>
               </Grid>

      {!open &&
        <Grid className='flex justify-end'>
          <Button variant='contained' size='small' onClick={onCreate}>Create New</Button>
        </Grid>}
      {open &&
        <Modal onClose={setOpen} onSave={formik.handleSubmit} formik={formik} isEdit={isEdit} >
          <div style={{ textAlign: "right" }}>
            <Button variant='outlined' onClick={() => setOpen(false)}>Close</Button>
          </div>
          <Grid container spacing={2} >
            <Grid item xs={12}> <Typography fontSize={16} fontWeight={600} color={"black"}>1. WareHouse Details</Typography></Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id='name' value={formik.values.name} title='WareHouse Name' multiple={false} placeholder='Enter company name' onchange={formik.handleChange} errorMsg={formik.touched.name && Boolean(formik.errors.name)} helperText={formik.touched.name && formik.errors.name} />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id='shortName' value={formik.values.shortName} title='Short Name' multiple={false} placeholder='Enter Short Name' onchange={formik.handleChange} errorMsg={formik.touched.shortName && Boolean(formik.errors.shortName)} helperText={formik.touched.shortName && formik.errors.shortName} />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id='address1' value={formik.values.address1} title='Address 1' multiple={true} placeholder='Enter address' onchange={formik.handleChange} errorMsg={formik.touched.address1 && Boolean(formik.errors.address1)} helperText={formik.touched.address1 && formik.errors.address1} />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id='address2' value={formik.values.address2} title='Address 2' multiple={true} placeholder='Enter address' onchange={formik.handleChange} errorMsg={formik.touched.address2 && Boolean(formik.errors.address2)} helperText={formik.touched.address2 && formik.errors.address2} />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id='pincode' value={formik.values.pincode} title='Pincode' multiple={false} placeholder='Enter pincode' onchange={formik.handleChange} errorMsg={formik.touched.pincode && Boolean(formik.errors.pincode)} helperText={formik.touched.pincode && formik.errors.pincode} />
            </Grid>

            <Grid item xs={12} md={4} lg={3}>
              <Country formik={formik} countryId={countryObj} />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <State formik={formik} stateId={stateObj} />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <City formik={formik} cityId={cityObj} />
            </Grid>
            <Grid item xs={12} md={4} lg={3} >
              <Typography variant="body1" my={1}> Main WareHouse</Typography>
              <FormControl sx={{ display: "flex" }}>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="mainWarehouse"
                  sx={{ flexDirection: "row", display: "flex" }}
                  onChange={formik.handleChange}
                >
                  <FormControlLabel
                    value="Yes"
                    control={<Radio size="small" checked={formik.values.mainWarehouse === 'Yes'} />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="No"
                    control={<Radio size="small" checked={formik.values.mainWarehouse === 'No'} />}
                    label="No"
                  />
                </RadioGroup>
                <Typography sx={{ color: "red", fontSize: 12 }}>{formik.touched.mainWarehouse && formik.errors.mainWarehouse}</Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} >
              <Divider />
            </Grid>
            <Grid item xs={12} >
              <Typography fontSize={16} fontWeight={600} color={"black"}>2. Contact Details</Typography>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id='contactname' value={formik.values.contactname} title='Name' multiple={false} placeholder='Enter contact name' onchange={formik.handleChange} errorMsg={formik.touched.contactname && Boolean(formik.errors.contactname)} helperText={formik.touched.contactname && formik.errors.contactname} />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id='phone' value={formik.values.phone} title='Phone' multiple={false} placeholder='Enter phone No' onchange={handlePhone} errorMsg={formik.touched.phone && Boolean(formik.errors.phone)} helperText={formik.touched.phone && formik.errors.phone} />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id='mobile' value={formik.values.mobile} title='Mobile' multiple={false} placeholder='Enter mobile No' onchange={handleMobile} errorMsg={formik.touched.mobile && Boolean(formik.errors.mobile)} helperText={formik.touched.mobile && formik.errors.mobile} />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id='email' value={formik.values.email} title='Email' multiple={false} placeholder='Enter email' onchange={formik.handleChange} errorMsg={formik.touched.email && Boolean(formik.errors.email)} helperText={formik.touched.email && formik.errors.email} />
            </Grid>
            <Grid item xs={12} >
              <Divider />
            </Grid>
            <Grid item xs={12} >
              <Typography fontSize={16} fontWeight={600} color={"black"}>3. Limitation</Typography>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id='limitation' value={formik.values.limitation} title='Month wise Expense Limitations' multiple={false} placeholder='Enter Limitation' onchange={formik.handleChange} errorMsg={formik.touched.limitation && Boolean(formik.errors.limitation)} helperText={formik.touched.limitation && formik.errors.limitation} />
            </Grid>
            <Grid item xs={12} >
              <Typography fontSize={16} fontWeight={600} color={"black"}>4. GST Details</Typography>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id='gstin' value={formik.values.gstin} title='GSTIN' multiple={false} placeholder='Enter gstin' onchange={formik.handleChange} errorMsg={formik.touched.gstin && Boolean(formik.errors.gstin)} helperText={formik.touched.gstin && formik.errors.gstin} />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id='fssai' value={formik.values.fssai} title='Pan Number' multiple={false} placeholder='Enter Pan Number' onchange={formik.handleChange} errorMsg={formik.touched.fssai && Boolean(formik.errors.fssai)} helperText={formik.touched.fssai && formik.errors.fssai} />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id='wallet_balance' value={formik.values.wallet_balance} title='Wallet Balance' multiple={false} placeholder='Enter wallet balance' onchange={formik.handleChange} errorMsg={formik.touched.wallet_balance && Boolean(formik.errors.wallet_balance)} helperText={formik.touched.wallet_balance && formik.errors.wallet_balance} />
            </Grid>
            <Grid item xs={12} md={4} lg={3} >
              <Typography variant="body1" my={1}> Gst Applicable</Typography>
              <FormControl sx={{ display: "flex" }}>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="gstApplicable"
                  sx={{ flexDirection: "row", display: "flex" }}
                  onChange={formik.handleChange}
                >
                  <FormControlLabel
                    value="Yes"
                    control={<Radio size="small" checked={formik.values.gstApplicable === 'Yes'} />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="No"
                    control={<Radio size="small" checked={formik.values.gstApplicable === 'No'} />}
                    label="No"
                  />
                </RadioGroup>
                <Typography sx={{ color: "red", fontSize: 12 }}>{formik.touched.gstApplicable && formik.errors.gstApplicable}</Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} >
              <Typography fontSize={16} fontWeight={600} color={"black"}>5. Bank Details</Typography>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id='bankAccNo' value={formik.values.bankAccNo} title='Bank Acc No' multiple={false} placeholder='Enter Bank Acc No' onchange={handleAcc} errorMsg={formik.touched.bankAccNo && Boolean(formik.errors.bankAccNo)} helperText={formik.touched.bankAccNo && formik.errors.bankAccNo} />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id='bankName' value={formik.values.bankName} title='Bank Name' multiple={false} placeholder='Enter Bank Name' onchange={formik.handleChange} errorMsg={formik.touched.bankName && Boolean(formik.errors.bankName)} helperText={formik.touched.bankName && formik.errors.bankName} />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id='accName' value={formik.values.accName} title='Account Holder Name' multiple={false} placeholder='Enter Account Holder Name' onchange={formik.handleChange} errorMsg={formik.touched.accName && Boolean(formik.errors.accName)} helperText={formik.touched.accName && formik.errors.accName} />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField id='ifscCode' value={formik.values.ifscCode} title='IFSC Code' multiple={false} placeholder='Enter IFSC Code' onchange={formik.handleChange} errorMsg={formik.touched.ifscCode && Boolean(formik.errors.ifscCode)} helperText={formik.touched.ifscCode && formik.errors.ifscCode} />
            </Grid>
          </Grid>
        </Modal>
      }

      <Grid className='bg-white rounded-md p-2 my-3'>
        <CustomDataGrid props={props} />
      </Grid>

      <Backdrop open={openDialog} sx={{ zIndex: 1350 }}>
        <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete} />
      </Backdrop>
<Backdrop open={openDialog1} sx={{zIndex:1250}}>
  <WarehouseStatus setOpen={setOpen} onCancel={setOpenDialog1} onSubmit={OnReset} setClosedStatus={setClosedStatus}
  warehouseId={selectedOutletId}
  closedStatus={closedStatus} // This should be an object with outlet IDs as keys

  />
 
</Backdrop>
<Backdrop open={openProduct} sx={{zIndex:1050}}>
  {/* <ProductMapping onCancel={setOpenProduct}   onSubmit={OnAssignProduct}

  /> */}

    <ProductMapping 
    onCancel={setOpenProduct}   onSubmit={OnAssignProduct} 
    fromOutlet={selectedOutlet} warehouseId={selectedOutletId} selectedOutletName={selectedOutletName}setSelectedOutletName={setSelectedOutletName}
    />

</Backdrop>
      <Backdrop open={openResetModal} sx={{ zIndex: 1250 }}>

        <Modal onClose={closeResetModal} onSave={handleResetWarehouse}>
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <Typography variant='h6' gutterBottom>Reset Confirmation</Typography>
            <Typography>Are you sure you want to reset the count for this warehouse?</Typography>
            <Grid container justifyContent="space-around" mt={3}>
              <Button variant="contained" color="primary" onClick={handleResetWarehouse}>Confirm</Button>
              <Button variant="outlined" color="secondary" onClick={closeResetModal}>Cancel</Button>
            </Grid>
          </div>
        </Modal>
      </Backdrop>

      {/* <Loader isLoader={isLoader}/> */}
    </Fragment>
  )
}

export default WareHouse;